import React from 'react';

function WindowLarge() {
  return (
    <div className="div-intro-window remove-flex-420">
      <div className="div-intro-content-container">
        <p>Greetings, my name is James Page and I'm a</p>
        <h1>Full Stack Web Developer</h1>
        <p>Building friendly and responsive web applications</p>
      </div>
    </div>
  );
}

export default WindowLarge;